import React from "react";
import "../styles/ProfileImages.css";
import profile3 from "../images/profile-2.jpg";

const ProfileImages = () => {
  return (
    <div className="profile-images-container">
      <div className="main-image-wrapper">
        <img src={profile3} alt="Srijan" className="main-profile-img" />
      </div>
      {/* <div className="side-images">
        <img src={profile2} alt="Srijan" className="side-img" />
        <img src={profile3} alt="Srijan" className="side-img" />
      </div> */}
    </div>
  );
};

export default ProfileImages;
